let module = 'LAS_WORKBENCH_ACTIONS_INTERFACE_'

export const STORE_NAME = 'las_workbench'

export const SET_INTERFACE = module + 'SET_INTERFACE'
export const INCREMENT_REQUEST_NUMBER = module + 'INCREMENT_REQUEST_NUMBER'
export const SET_TARGET_DATA = module + 'SET_TARGET_DATA'
export const SET_METRICS = module + 'SET_METRICS'
export const SET_AUDIENCE_SIZE = module + 'SET_AUDIENCE_SIZE'
export const SET_HISTORICAL_VIEWERSHIP = module + 'SET_HISTORICAL_VIEWERSHIP'
export const SET_UNIVERSE = module + 'SET_UNIVERSE'
export const SET_SELECTED_NETWORKS = module + 'SET_SELECTED_NETWORKS'
export const SET_DAY_PART_NETWORKS = module + 'SET_DAY_PART_NETWORKS'
export const SET_SELECTED_VIEWERSHIP_NETWORKS = module + 'SET_SELECTED_VIEWERSHIP_NETWORKS'
export const REMOVE_FROM_SELECTED_DAY_PART_NETWORKS = module + 'REMOVE_FROM_SELECTED_DAY_PART_NETWORKS'
export const REMOVE_ALL_DAY_PART_NETWORKS = module + 'REMOVE_ALL_DAY_PART_NETWORKS'
export const SET_LOADING = module + 'SET_LOADING'
export const SET_VIEWING_STREAM = module + 'SET_VIEWING_STREAM'
export const RESET = module + 'RESET'

const actions = {
  [SET_INTERFACE]: (context, inter) => {
    context.commit(SET_INTERFACE, inter)
  },
  [INCREMENT_REQUEST_NUMBER]: (context) => {
    context.commit(INCREMENT_REQUEST_NUMBER)
  },
  [SET_TARGET_DATA]: (context, data) => {
    const { metrics, audienceSize, historicalViewership, universe } = data
    context.commit(SET_METRICS, metrics)
    context.commit(SET_AUDIENCE_SIZE, audienceSize)
    context.commit(SET_HISTORICAL_VIEWERSHIP, historicalViewership)
    context.commit(SET_UNIVERSE, universe)
  },
  /**
   * this will set the viewership and day parts networks
   */
  [SET_SELECTED_NETWORKS]: (context, networks) => {
    context.commit(SET_DAY_PART_NETWORKS, networks)
    context.commit(SET_SELECTED_VIEWERSHIP_NETWORKS, networks)
    let inter = context.state.interface
    if (inter) {
      inter.onTargetDefinitionChange({
        context: context,
        targetDefinition: context.getters.newTargetDefinition,
      })
    }
  },
  [REMOVE_FROM_SELECTED_DAY_PART_NETWORKS]: ({ commit }, network) => {
    commit(REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, network)
  },
  [REMOVE_ALL_DAY_PART_NETWORKS]: (context) => {
    context.commit(REMOVE_ALL_DAY_PART_NETWORKS)
  },
  [SET_LOADING]: ({ commit }, v) => {
    commit(SET_LOADING, v)
  },
  [SET_VIEWING_STREAM]: ({ commit }, v) => {
    commit(SET_VIEWING_STREAM, v)
  },
  [RESET]: (context) => {
    context.commit(RESET)
  },
}
export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/LAS/store/actions.js